import { StatementStatusCell } from "./statement-status-cell";

export const STATEMETS_TABLE_COLUMNS_WITHOUT_SELECTION = [
  {
    field: "fileName",
    headerName: "Statement name",
    flex: 1,
    minWidth: 150,
    cellRenderer: (params) => {
      const { fileName, fileUrl } = params.data;
      return (
        <a href={fileUrl} target="_blank" rel="noopener noreferrer" download>
          {fileName}
        </a>
      );
    },
  },
  {
    field: "createdAt",
    headerName: "Creation date",
    valueFormatter: (params) => new Date(params.value).toLocaleDateString(),
    minWidth: 120,
  },
  {
    field: "numberOfPages",
    headerName: "# of pages",
    flex: 0.5,
    minWidth: 100,
  },
  {
    field: "status",
    headerName: "Status",
    cellRenderer: (params) => {
      const { id, status } = params.data;
      return <StatementStatusCell statementId={id} status={status} />;
    },
    flex: 0.8,
    minWidth: 120,
  },
];

export const STATEMETS_TABLE_COLUMNS = [
  {
    checkboxSelection: true,
    headerCheckboxSelection: true,
    ...STATEMETS_TABLE_COLUMNS_WITHOUT_SELECTION[0],
  },
  ...STATEMETS_TABLE_COLUMNS_WITHOUT_SELECTION.slice(1),
];
